import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import DevisFormContent from './DevisFormContent';

interface FormData {
  clientType: string;
  propertyType: string;
  diagnostics: string[];
  name: string;
  email: string;
  phone: string;
  address: string;
  constructionYear: string;
  surface: string;
}

interface DevisFormProps {
  variant: 'hero' | 'modal';
  isOpen?: boolean;
  onClose?: () => void;
  formStep: number;
  formData: FormData;
  onStepChange: (step: number) => void;
  onFormChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
  onDiagnosticToggle: (diagnostic: string) => void;
  onSubmit: (e: React.FormEvent) => void;
}

const DevisForm: React.FC<DevisFormProps> = ({ 
  variant, 
  isOpen = true, 
  onClose,
  formStep,
  formData,
  onStepChange,
  onFormChange,
  onDiagnosticToggle,
  onSubmit
}) => {
  if (variant === 'hero') {
    return (
      <motion.div
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.5 }}
        className="hidden lg:block w-[450px] relative z-20"
      >
        <DevisFormContent
          formStep={formStep}
          formData={formData}
          onStepChange={onStepChange}
          onFormChange={onFormChange}
          onDiagnosticToggle={onDiagnosticToggle}
          onSubmit={onSubmit}
        />
      </motion.div>
    );
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 overflow-hidden">
          <div 
            className="absolute inset-0 bg-black/80 backdrop-blur-sm"
            onClick={onClose}
          />
          <div className="absolute inset-0 pointer-events-none">
            <div className="h-full w-full flex justify-end">
              <div
                className="w-full max-w-lg h-full pointer-events-auto"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="h-full relative">
                  <button
                    onClick={onClose}
                    className="absolute right-4 top-4 text-white hover:text-white/90 transition-colors p-2 rounded-full z-10"
                  >
                    <X className="h-6 w-6" />
                  </button>
                  <div className="h-full overflow-y-auto py-6 px-6">
                    <DevisFormContent
                      formStep={formStep}
                      formData={formData}
                      onStepChange={onStepChange}
                      onFormChange={onFormChange}
                      onDiagnosticToggle={onDiagnosticToggle}
                      onSubmit={onSubmit}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default DevisForm;